import React, { Component } from 'react';
import { useAppContext } from '../AppContext';

class ClassProps extends Component {
  counter() {
    const { actions } = this.props;
    actions.setData({
      current: this.props.state.current + 1
    });
    console.group('this props');
    console.log(this.props);
    console.groupEnd('this props');
  }

  render() {
    return (
      <div>
        <strong>Class HOC props: </strong>
        <button onClick={() => this.counter()}>Increment</button>
        <textarea readOnly value={JSON.stringify(this.props.state)}></textarea>
      </div>
    );
  }
}

export default useAppContext(ClassProps);
